const utm = require('utm');

class GMSGeometry {
    static latLngString(coord) {
        if ( coord === null ) {
            return null
        }
        return 'Lat: ' + coord.lat.toFixed(6) + ', Long: ' + coord.lng.toFixed(6);
    }

    static latLngToUtm(coord) {
        if ( coord === null ) {
            return null
        }
        return utm.fromLatLon(coord.lat, coord.lng);
    }

    static latLngToUtmString(coord) {
        const _utm = GMSGeometry.latLngToUtm(coord);
        if ( _utm === null ) {
            return null
        }
        return '' + _utm.zoneNum + _utm.zoneLetter + ' , X =  ' + _utm.easting.toFixed(2) + ' , Y = ' + _utm.northing.toFixed(2);
    }
}

export default GMSGeometry;


// WEBPACK FOOTER //
// ./src/Helpers/GMSGeometry.js